import { Component, forwardRef, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { IdProvider } from '../id-provider';

@Component({
    selector: 'app-yes-no-group-button',
    templateUrl: './yes-no-group-button.component.html',
    styleUrls: ['./yes-no-group-button.component.scss'],
    imports: [ReactiveFormsModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => YesNoGroupButtonComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => YesNoGroupButtonComponent),
            multi: true
        }
    ]
})
export class YesNoGroupButtonComponent implements ControlValueAccessor, OnDestroy {
  public id: string = IdProvider.getNextId();
  public form: FormGroup<{formValue: FormControl<boolean | null>}>;
  private subscriptions: Subscription[] = [];

  constructor(private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      formValue: this.formBuilder.control<boolean | null>(false)
    });

    this.subscriptions.push(
      // any time the inner form changes update the parent of any change
      this.form.valueChanges.subscribe(value => {
        this.onChange(value?.formValue);
        this.onTouched();
      })
    );
  }

  public onChange: any = () => {};
  public onTouched: any = () => {};
  public disabled: boolean = false;

  writeValue(value: any): void {
    if (value == null) {
      value = false;
    }

    this.form.controls.formValue.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  registerOnChange(fn: (value: any) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    if (this.disabled) {
      this.form.controls.formValue.disable();
    } else {
      this.form.controls.formValue.enable();
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  validate(_: FormControl) {
    return null;
  }

}
